import React from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';
import {BrowserRouter} from 'react-router-dom';

export interface AppContextProps {
    queryClient?: QueryClient;
    children: React.ReactNode;
}

export const AppContext: React.FC<AppContextProps> = (props) => {
    // Uncomment to enable MSW request interceptors.
    // const mswLoaded = useMsw();

    const queryClient =
        props.queryClient ||
        new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: Infinity,
                    retry: false,
                },
            },
        });

    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>{/* mswLoaded && */ props.children}</BrowserRouter>
        </QueryClientProvider>
    );
};
